import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
export const Problem = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-399">
      <p className="mb-6 leading-relaxed" data-id="element-400">
        Het is 17:30 op een doordeweekse avond. Je staat in de keuken en wilt
        beginnen met koken, maar als je de koelkast opendoet staar je naar lege
        schappen. Een snelle boodschap van 20 minuten zou perfect zijn... maar
        dat kan niet.
      </p>
      <p className="mb-6 leading-relaxed font-semibold" data-id="element-401">
        "Luna kan niet alleen blijven."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-402">
        Want zodra jij je jas pakt raakt Luna al in de stress.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-403">
        Dus sta je daar, gefrustreerd, hongerig, en gevangen in je eigen huis
        door de angst van je hond. Je kunt niet snel even naar de supermarkt. Je
        kunt niet spontaan bij vrienden langsgaan. Je kunt niet eens een avondje
        uit met je partner zonder dagen van tevoren een oppas te regelen.
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-404">
        Gevangen door de liefde voor je hond
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-405">
        En het ergste? Hoe meer je "oefent" met kort weggaan, hoe erger het
        lijkt te worden. Maanden van training, eindloze sessies van "even vijf
        minuten weg", en toch schiet Luna nog steeds in paniek zodra jij je
        sleutels pakt.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-406">
        Als dit herkenbaar klinkt, dan moet je dit lezen. Want wat ik je ga
        vertellen zal alles veranderen wat je dacht te weten over
        verlatingsangst.
      </p>
      <div className="w-full mb-6" data-id="element-407">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kWYBwrRbSKDwjRzyA4wH7y/freepik__the-style-is-candid-image-photography-with-natural__77408.png" alt="Vrouw die haar hond knuffelt, gevangen in haar huis door verlatingsangst" className="w-full h-auto rounded-lg shadow-md" data-id="element-408" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-409">
          "Ik ben een gevangene van mijn eigen liefde voor mijn hond"
        </p>
      </div>
      <h3 className="text-lg font-bold text-blue-800 mb-3" data-id="element-410">
        Wat baasjes vaak niet weten
      </h3>
      <p className="mb-6 leading-relaxed" data-id="element-411">
        Na jaren van het begeleiden van hondenbezitters met "verlatingsangst"
        heb ik een schokkende ontdekking gedaan:{' '}
        <strong data-id="element-412">
          De meeste van de honden die we behandelen heeft helemaal geen
          verlatingsangst.
        </strong>
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-413">Laat dat even tot je doordringen.</p>
      <p className="mb-6 leading-relaxed" data-id="element-414">
        Er is een ander probleem dat getriggerd wordt zodra het baasje van huis
        gaat. Dan lijkt het al snel op "angst om verlaten te worden".
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-415">
        Al die maanden van oefening. Al die frustratie. Al die gemiste kansen.
        En het probleem was iets compleet anders.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-416">
        Het probleem is dat iedereen - trainers, dierenartsen, zelfs
        gedragstherapeuten - kijkt naar het symptoom: de hond wordt gestrest als
        je weggaat. Dus wat doen ze? Ze behandelen het symptoom. "Oefen maar.
        Hij leert vanzelf dat alleen zijn niet eng is. Bouw langzaam op."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-417">
        Maar zelden gaat iemand aan de slag met <strong data-id="element-418">WAAROM</strong> de hond
        zo gestrest wordt.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-419">
        <a href="https://training.stresslessdogs.nl/va-video" className="text-blue-600 hover:underline" data-id="element-420">
          Tijdens de intakes voor onze verlatingsangst coaching
        </a>{' '}
        geven de meeste baasjes dan ook aan geen idee te hebben wat er echt
        onder ligt. Laat staan dat ze al aan het echte kernprobleem hebben
        gewerkt.
      </p>
    </section>;
};